import { League } from '@/types/api.generated';

export const nflFullSeason = (league?: League) => league === League.NflFullSeason;

export const isUFC = (league?: League) => league === League.Ufc;

export const isPGA = (league?: League) => league === League.Pga;

export const isCollegeSport = (league?: League) => league === League.Cfb || league === League.Cbb;

export const hasPositionFilters = (league: League) => ![League.Pga, League.Ufc].includes(league);
